import createDummyGridBox from "./createDummyGridBox";

function createDummyGridRow (rows, columns) {

                let out_array = []
                for(let i = 0 ; i < rows ; i++) {
                                out_array.push(createDummyGridBox(columns))
                }
                return out_array
}

export default createDummyGridRow